module.exports = __webpack_public_path__ + "static/media/BG_48.6fb68566.png";